<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="ui-module-card ui-module-fade-in-up solicitud-cursos-shell" flat>
          <v-col cols="12">
            <v-data-table
              class="suggestion-table ui-module-table"
              :headers="headers"
              :items="itemsCurso"
              dark
              item-key="id"
              hide-default-footer
              disable-pagination
              dense
              show-expand
              :expanded.sync="expanded"
            >
              <template v-slot:[`item.CUIP`]="{ item }">
                <div>{{ item.CUIP }}</div>
              </template>
              <template v-slot:[`item.nombreCompleto`]="{ item }">
                <div>{{ item.nombreCompleto }}</div>
              </template>
              <template v-slot:[`item.sugerenciaSubcategoria`]="{ item }">
                <div>{{ item.sugerenciaSubcategoria }}</div>
              </template>
              <template v-slot:[`item.sugerencia`]="{ item }">
                <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px">
                  {{ item.sugerencia }}
                </div>
              </template>
              <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length">
                  <div class="pa-4">
                    <strong>Sugerencia completa:</strong>
                    <div>{{ item.sugerencia }}</div>
                  </div>
                </td>
              </template>
              <template v-slot:no-data>
                <div class="text-h6 justify-center" align="center">
                  No hay solicitudes de cursos a personal registradas
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      headers: [
        { text: 'CUIP', value: 'CUIP' },
        { text: 'Nombre completo', value: 'nombreCompleto' },
        { text: 'Subcategoría', value: 'sugerenciaSubcategoria' },
        { text: 'Sugerencia', value: 'sugerencia' },
      ],
      expanded: [],
    }
  },
  computed: {
    ...mapGetters('sugerenciaCursos', {
      sugerenciaCursos: 'getSugerenciaCursos',
    }),
    itemsCurso() {
      return this.sugerenciaCursos.map((sugerencia, idx) => ({
        id: sugerencia.id || idx,
        sugerencia: sugerencia.comentario || sugerencia.sugerencia || '',
        sugerenciaSubcategoria: sugerencia.Curso?.subcategoria || '',
        nombreCompleto: [
          sugerencia.Person?.nombre,
          sugerencia.Person?.segundoNombre,
          sugerencia.Person?.apaterno,
          sugerencia.Person?.amaterno,
        ]
          .filter(Boolean)
          .join(' '),
        CUIP: sugerencia.Person?.CUIP || '',
        ...sugerencia,
      }))
    },
  },
  watch: {
    expanded(val) {
      if (val.length > 1) {
        this.expanded = [val[val.length - 1]]
      }
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Sugerencias de Cursos de Profesionalización */

.tooltip-ancho-custom {
  display: block;
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}

/* Card principal */
::v-deep .v-card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover {
  border-color: rgba(0, 210, 160, 0.3);
  box-shadow: 0 12px 40px rgba(0, 210, 160, 0.25);
}

/* Card title */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 20px 24px;
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 20px 20px 0 0;
}

::v-deep .v-card-title .headline {
  color: #26de81 !important;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* Data Table */
::v-deep .suggestion-table.v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
  border: 1px solid rgba(0, 210, 160, 0.15);
  overflow: hidden;
}

::v-deep .suggestion-table > .v-data-table__wrapper {
  background: transparent !important;
}

::v-deep .suggestion-table > .v-data-table__wrapper > table {
  background: transparent !important;
}

::v-deep .suggestion-table > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}

::v-deep .suggestion-table > .v-data-table__wrapper > table > thead {
  background: rgba(0, 210, 160, 0.15) !important;
}

/* Encabezados de tabla */
::v-deep .suggestion-table .v-data-table-header {
  background: rgba(0, 0, 0, 0.3) !important;
}

::v-deep .suggestion-table .v-data-table-header th {
  color: #26de81 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(0, 210, 160, 0.3) !important;
  padding: 16px !important;
  background: transparent !important;
}

/* Filas de la tabla */
::v-deep .suggestion-table tbody tr {
  transition: all 0.3s ease;
  border-radius: 8px;
  background: transparent !important;
}

::v-deep .suggestion-table tbody tr:hover {
  background: rgba(0, 210, 160, 0.1) !important;
  transform: scale(1.005);
  box-shadow: 0 4px 12px rgba(0, 210, 160, 0.2);
}

::v-deep .suggestion-table tbody td {
  color: #e0e0e0 !important;
  background: transparent !important;
  border-bottom: 1px solid rgba(0, 210, 160, 0.1) !important;
  padding: 16px !important;
}

/* Loading state */
::v-deep .v-data-table__progress {
  background: rgba(0, 210, 160, 0.1) !important;
}

::v-deep .v-data-table__progress .v-progress-linear__determinate {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
}

/* Empty state */
::v-deep .suggestion-table .v-data-table__empty-wrapper {
  background: transparent !important;
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Expanded row */
::v-deep .suggestion-table .v-data-table__expanded__content {
  background: rgba(0, 0, 0, 0.25) !important;
  border-left: 3px solid #00d2a0 !important;
}

::v-deep .suggestion-table .v-data-table__expanded__content td {
  color: #e0e0e0 !important;
  padding: 16px 24px !important;
  background: transparent !important;
}

::v-deep .suggestion-table .v-data-table__expanded__content strong {
  color: #26de81 !important;
  font-weight: 700;
}

/* Expand icon */
::v-deep .suggestion-table .v-data-table__expand-icon {
  color: #00d2a0 !important;
}

::v-deep .suggestion-table .v-data-table__expand-icon:hover {
  color: #26de81 !important;
  transform: scale(1.2);
}

::v-deep .suggestion-table .v-data-table__expand-icon--active {
  color: #26de81 !important;
}

/* No data message */
::v-deep .suggestion-table .text-h6 {
  color: #e0e0e0 !important;
  font-weight: 600;
  padding: 32px 16px;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(0, 210, 160, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}

/* Animación de entrada administrada por ui-module-fade-in-up */

.solicitud-cursos-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .solicitud-cursos-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .solicitud-cursos-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
